import { render, staticRenderFns } from "./Int.vue?vue&type=template&id=252a7534&"
import script from "./Int.vue?vue&type=script&lang=js&"
export * from "./Int.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports